import { CaseData } from '../PageContent'

import { CaseImage } from '../CaseImage'
import { CaseVideo } from '../CaseVideo'

interface LayoutProps {
 data: CaseData
 files: {
  type: string
  src: string
 }[]
}

export function Layout4({ data, files }: LayoutProps) {
 return (
  <div className="container">
   {files
    .filter(item => item.type === 'video')
    .map((item, index) => (
     <div className="flex flex-wrap" key={index}>
      <div
       className="w-full pt-2.5"
       data-aos={index % 2 === 0 ? 'fade-left' : 'fade-right'}
      >
       <CaseVideo
        videoIndex={index}
        video={item.src}
        className="main-embed-container"
       />
      </div>
     </div>
    ))}
   {files
    .filter(item => item.type === 'image')
    .map((item, index) => (
     <div className="flex flex-wrap" key={index}>
      <div className="w-full relative mt-2.5" data-aos="fade-right">
       <CaseImage
        imageIndex={index}
        folder={data.cf_client_name}
        image={item.src}
       />
      </div>
     </div>
    ))}
  </div>
 )
}
